import React, { useState, useEffect, useStyles } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles_2 = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: 'large',
        fontWeight: 'bold',
        backgroundColor: '#55ba5e',
        color: '#fff',
    },
}));

export default function Catering() {
    const classes = useStyles_2();

    // const [accCatering, setAccCatering] = useState(null);
    const [docs, setDocs] = useState(null);

    function shortenItem(item) {
        let short = item.split('/');
        let letztesItem = short.length - 1;
        return short[letztesItem];
    }

    function browseDir(item) {        
        return (item.dirName && item.dirName !== null) ? (
            <>
                <Accordion style={{ marginLeft: '40px', border: '4px solid white' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={item.dirName}
                        id={item.dirName}
                        className={classes.heading}
                    >
                        <Typography className={classes.heading}>{shortenItem(item.dirName)}</Typography>
                    </AccordionSummary>
                    {item.files.length > 0 ? (
                        <AccordionDetails>
                            <ol>
                                {item.files.length > 0
                                    ? item.files.map((x) => {
                                          return (
                                              <li className="box_highlight" id="catering">
                                                  <a href={x.fileName} target="_blank">
                                                      {shortenItem(x.fileName)}
                                                  </a>
                                              </li>
                                          );
                                      })
                                    : ''}
                            </ol>
                        </AccordionDetails>
                    ) : (
                        ''
                    )}

                    {item.children.length > 0 ? item.children.map((it) => browseDir(it)) : ''}
                </Accordion>
            </>
        ) : (
            ''
        );
    }

    // useEffect(() => {

    //   accCatering !== null ? console.log(accCatering) : console.log("leer")}, [accCatering])

    useEffect(() => {
        var requestOptions = {
            method: 'GET',
            redirect: 'manual',
            credentials: 'same-origin',
        };

        fetch('https://intranet-backend.procuratio.com/get_job_catering.php', requestOptions)
            .then((response) => response.json())
            .then((result) => {
                setDocs([result.data]);
            })
            .catch((error) => console.log('error', error));

        // setUser(localStorage.getItem("ldap_username"));

        let token = localStorage.getItem('token');
        var requestOptions = {
            method: 'GET',
            redirect: 'follow',
            credentials: 'same-origin',
            headers: {
                Authorization: 'Bearer ' + token,
            },
        };
    }, []);

    return (
        <div id="wrapper" style={{ padding: '50px' }}>
            <div>
                <div className="section_title" style={{ marginBottom: '10px' }}>
                    Meetingunterlagen Catering
                </div>

                <div className="rounded_corner_right"></div>
                <div className="DA_info_container">
                    <div className="box_highlight">{(docs && (docs !== null)) && docs.map((e) => browseDir(e))}</div>
                </div>
            </div>
        </div>
    );
}


